import React, { useCallback } from 'react'
import List from '../BaseAssetsList'
import Item from './ListItem'
import { HeaderContainer } from './HeaderContainer'
import { SOURCE_FILE_TYPES } from '~/enums'

export default function TransitionAssetsList(props) {
  const sort = useCallback(
    items => items.length ? [ ...items ].sort(((a, b) => a.name.localeCompare(b.name))) : items,
    []
  )

  return (
    <List
      {...props}
      sort={sort}
      header={<HeaderContainer type={SOURCE_FILE_TYPES.TEXT} />}
      ItemComponent={props => <Item {...props} />}
    />
  )
}
